import onboardingWelcomePageImage from './onboarding/welcome-background.png';
import splashScreenImage from './splash-screen.svg';
import splashScreenMobile from './splash-screen-mobile.svg';
import splashScreenMobileDishes from './splash-screen-mobile-dishes.svg';
import dishes from './dishes.png';
import maintenanceDishes from './maintenance-dishes.png';
import screenTooSmall from './screen-too-small.png';
export var Images = {
    splashScreen: splashScreenImage,
    splashScreenMobile: splashScreenMobile,
    splashScreenMobileDishes: splashScreenMobileDishes,
    onboardingWelcomePage: onboardingWelcomePageImage,
    dishes: dishes,
    maintenanceDishes: maintenanceDishes,
    screenTooSmall: screenTooSmall,
};
